import React, { Component } from 'react'

import { site, fb, email, address } from '../../lib/text'

class Footer extends Component {
    render(){
        return (
            <footer id="footer">
                <div className="container">
                    <div>
                        <div>
                            <span>
                                <b>Escríbinos</b> a <a
                                    href={`mailto:${email}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{ email }</a> o
                            </span>
                        </div>
                        <div>
                            <span>
                                <b>encontranos</b> en <a
                                    href={ fb }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >facebook</a>
                            </span>
                        </div>
                        <div className="address">{ site }, { address }</div>
                    </div>
                    <div></div>
                </div>
            </footer>
        )
    }
}

export default Footer